import App from './App';
import Calendar from './Calendar';
import Page from './Page';
import Slots from './Slots';
import UserBookingRepo from './UserBookingRepo';
import UserRepo from './UserRepo';

const store = {
    app: App,
    page: Page,
    slots: Slots,
    calendar: Calendar,
    userRepo: UserRepo,
    get user() {
        return UserRepo.user;
    },
    userBookingsRepo: UserBookingRepo
};

window.store = store;

export default store;
